import React from 'react';
import { links } from '../data/site';
export function Footer() {
  return <footer className="border-t border-rule" data-id="element-41" data-mp="3gf94guwt048f">
      <div className="max-w-content mx-auto px-6 lg:px-10 py-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-5" data-id="element-42" data-mp="3gg0yw2enzvx4">
        <div className="sm:max-w-xl" data-id="element-43" data-mp="32lrnnhvi55m3">
          <p className="font-serif text-lg text-ink" data-id="element-44" data-mp="36oxw8w6378vq">Craig Thomas</p>
          <p className="mt-1 text-sm leading-relaxed text-ink-mute" data-id="element-45" data-mp="36n3grxdl48z1">
            Fractional Transformation Executive · Strategy-to-Execution · Leadership Transitions ·
            Operating Systems · Applied AI
          </p>
          <p className="mt-1 text-sm text-ink-mute" data-id="element-46" data-mp="3leviv7odbqit">Portland, Oregon</p>
        </div>

        <div className="flex items-center gap-6 text-sm" data-id="element-47" data-mp="3qd6pzana3mxc">
          <a href={links.linkedin} target="_blank" rel="noopener noreferrer" className="text-ink-soft hover:text-clay transition-colors duration-200" data-id="element-48" data-mp="3qblwlocpaa12">
            LinkedIn
          </a>
          <a href={links.booking} target="_blank" rel="noopener noreferrer" className="text-ink-soft hover:text-clay transition-colors duration-200" data-id="element-49" data-mp="3l9agxskjxm96">
            Book a Conversation
          </a>
          <span className="text-ink-mute" data-id="element-50" data-mp="3v91b1t579z8q">© {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>;
}